export enum JobStatus {
  inProgress = 'In Progress',
  memberReview = 'Member Review',
  updatesRequested = 'Updates Requested',
  memberReviewResent = 'Member Review (Re-sent)',
  awaitingApproval = 'Awaiting Approval',
  noProcessing = 'No Processing',
  completed = 'Completed'
}
